import "./StepBadge.scss";

interface StepBadgeProps {
  value: number;
  active: boolean;
}

export default function StepBadge({ value, active }: StepBadgeProps) {
  return <div className={`StepBadge${active ? " active" : ""}`}>{value}</div>;
}
